// extracted by mini-css-extract-plugin
module.exports = {"w1eil6in":"w1eil6in","background-img":"background-img","mdezdqu":"mdezdqu"};